<form #createAlergiaForm="ngForm">
    <app-custom-modal #modal [title]="'Editar alergia'"
        [subtitle]="'Preencha os campos abaixo para editar uma nova alergia'" (onCloseClick)="modal.close()"
        (onSaveClick)="save()" [saveLabel]="'Salvar  →'" [saveDisabled]="createAlergiaForm.invalid || saving">
        <div class="container">
            <div class="mb-4">
                <label for="substancia" class="form-label required">Substância ou agente causador</label>
                <input type="text" class="form-control" name="substancia" maxlength="32" [(ngModel)]="alergia.substancia"
                    #substanciaModel="ngModel" #substanciaEl id="substancia" required placeholder="Digite aqui" />
                <abp-validation-summary [control]="substanciaModel" [controlEl]="substanciaEl"></abp-validation-summary>
            </div>

             <div class="mb-4">
                <label for="tipoAlergia" class="form-label required">Tipo de alergia</label>
                <select name="tipoAlergia" id="tipoAlergia" class="form-control" required [(ngModel)]="alergia.tipoAlergia">
                    <option *ngFor="let tipo of tiposAlergias.TiposAlergia" [value]="tipo.type">{{tipo.name}}</option>
                </select>
            </div>

            <div class="mb-4">
                <label for="observacao" class="form-label">Observações</label>
                <input type="text" class="form-control" name="observacao" [(ngModel)]="alergia.observacao"
                    #observacaoModel="ngModel" #observacaoEl id="observacao" placeholder="Digite aqui" />
                <abp-validation-summary [control]="observacaoModel" [controlEl]="observacaoEl"></abp-validation-summary>
            </div>
        </div>
    </app-custom-modal>
</form>